// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"DlpCountDown_sectionWrapper__hnuSo","countDownWrapper":"DlpCountDown_countDownWrapper__xLRIT"};